export const createTreeItemId = (
    source: string,
    family: string,
): string => {
    return `${source}-${family}`;
};
